(() => {
  const initialize = () => {
    document.querySelectorAll('.kd-marquee-toggle').forEach(button => {
      if (button.dataset.bound) return;
      button.dataset.bound = 'true';
      button.addEventListener('click', () => {
        const paused = button.getAttribute('aria-pressed') !== 'true';
        button.setAttribute('aria-pressed', String(paused));
        button.setAttribute('aria-label', paused ? button.dataset.playLabel : button.dataset.pauseLabel);
        button.querySelector('span').textContent = ''; 
        button.closest('.kd-brands').classList.toggle('is-paused', paused);
      });
    });
    document.querySelectorAll('.kd-mobile-nav').forEach(menu => {
      if (menu.dataset.bound) return;
      menu.dataset.bound = 'true';
      menu.querySelectorAll('a').forEach(link => link.addEventListener('click', () => menu.removeAttribute('open')));
      menu.addEventListener('keydown', event => {
        if (event.key === 'Escape') { menu.removeAttribute('open'); menu.querySelector('summary').focus(); }
      });
    });
  };
  initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
(() => {
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (reduced.matches || !('IntersectionObserver' in window) || window.Shopify?.designMode) return;
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) { entry.target.classList.add('kd-reveal-visible'); observer.unobserve(entry.target); }
    });
  }, { threshold: 0.08, rootMargin: '0px 0px -25px 0px' });
  document.querySelectorAll('.kd-about-grid, .kd-capability, .kd-process-step, .kd-shiftbilt-copy, .kd-channel-grid').forEach(element => {
    element.classList.add('kd-reveal-pending'); observer.observe(element);
  });
  reduced.addEventListener('change', event => {
    if (event.matches) { document.querySelectorAll('.kd-reveal-pending').forEach(element => element.classList.add('kd-reveal-visible')); observer.disconnect(); }
  });
})();
